import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { logger } from "common/utilities/logger";
import { followCollectionFailure, followCollectionSuccess } from "domains/collection/actions";
import type { FollowCollectionAction } from "domains/collection/actionTypes";

export function* followCollectionSaga({ payload }: FollowCollectionAction) {
  try {
    yield apiFetch(`collection/${payload.id}/follow`, { method: "PUT" });
    yield put(followCollectionSuccess(payload.id));
  } catch (error) {
    logger.error(`[followCollectionSaga] Failed to follow collection with ID '${payload.id}'`, error);
    yield put(followCollectionFailure(payload.id));
  }
}
